import { __extends } from "tslib";
import React from 'react';
export default function uploadThumbWrapper(UploadThumb) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(UploadThumbWrapper, _super);
            function UploadThumbWrapper() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            UploadThumbWrapper.prototype.render = function () {
                var componentData = this.props.componentData;
                return React.createElement(UploadThumb, { fileId: componentData.fileId });
            };
            return UploadThumbWrapper;
        }(React.Component)),
        _a.customClassName = function (componentData, theme, styles, isMobile) {
            return theme['uploadDndPlugin'];
        },
        _a;
}
//# sourceMappingURL=UploadThumbWrapper.js.map